import { render } from "./Subprogram.vue?vue&type=template&id=33cccb2c"
import script from "./Subprogram.vue?vue&type=script&lang=js"
export * from "./Subprogram.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__